(function() {
    angular.module('tmx-app').controller('GuarantorIDDetailDialogController', ['$mdDialog','$scope','tmxUtility','TMX_FINANCE_CONSTANTS','TmxPersonNationalIdentifier','lookupService','showAddButton','guarantorTabEditPrivilege', 'ToastService', 
  
        function GuarantorIDDetailDialogController($mdDialog,$scope,tmxUtility,TMX_FINANCE_CONSTANTS,TmxPersonNationalIdentifier,lookupService,showAddButton,guarantorTabEditPrivilege,ToastService) {
      
            $scope.vm = {};
            $scope.vm.NationalIdentifierData = TmxPersonNationalIdentifier;
            var exists = tmxUtility.exists;
            var LkpHiddenValue = TMX_FINANCE_CONSTANTS.LOOKUP_HV;
            $scope.vm.lookup = {};
            $scope.vm.lookup.IdentificationDocumentTypes = lookupService.getLocalLookupsByType('IdentificationDocumentTypes');  
            $scope.vm.lookup.Nationality = lookupService.getLocalLookupsByType('Nationality');
            $scope.vm.lookup.CountryLkp = lookupService.getLocalLookupsByType('RESIDENCE');

            $scope.expiryDateRequired = false;
            $scope.showOk = true;
            $scope.showAdd = showAddButton;
            $scope.guarantorTabEditPrivilege = guarantorTabEditPrivilege;
            $scope.NationalIdTypeLkpChange = function (NationalIdTypeLkp) {
                if (exists(NationalIdTypeLkp)) {
                    var HiddenValue = lookupService.getLookupById(NationalIdTypeLkp).HiddenValue;
                }
                if(exists($scope.vm.NationalIdentifierData.NationalityLkp)){
                    var NatVisibleValue = lookupService.getLookupById($scope.vm.NationalIdentifierData.NationalityLkp).VisibleValue;
                }
                    if (exists(NatVisibleValue) && LkpHiddenValue.lebHiddenValue.Lebanon != NatVisibleValue) //Beneifical Owner or Guarantor 
                        $scope.expiryDateRequired = true;
                    else if((exists(HiddenValue) && LkpHiddenValue.lebHiddenValue.Passport == HiddenValue))
                        $scope.expiryDateRequired = true;
                    else 
                    {$scope.expiryDateRequired = false;
                    //$scope.NationalIdTypeLkpChange($scope.vm.NationalIdentifierData.NationalIdTypeLkp);
                    };
            }
             $scope.NationalityLkpChange = function (NationalityLkp) {  
                if (exists($scope.vm.NationalIdentifierData.NationalIdTypeLkp)) {
                    var HiddenValue = lookupService.getLookupById($scope.vm.NationalIdentifierData.NationalIdTypeLkp).HiddenValue;
                }
                if(exists(NationalityLkp)){
                    var NatVisibleValue = lookupService.getLookupById(NationalityLkp).VisibleValue;
                }
                    if(exists(NatVisibleValue) && LkpHiddenValue.lebHiddenValue.Lebanon != NatVisibleValue) //Beneifical Owner or Guarantor 
                        $scope.expiryDateRequired = true;
                        else if((exists(HiddenValue) && LkpHiddenValue.lebHiddenValue.Passport == HiddenValue)) //Beneifical Owner or Guarantor 
                        $scope.expiryDateRequired = false;
                        else
                        {$scope.expiryDateRequired = false;
                        //$scope.NationalIdTypeLkpChange($scope.vm.NationalIdentifierData.NationalityLkp);
                        };
            }
            $scope.ok = function(form) {
                form.$submitted=true;
                if(form.$valid){
                    $mdDialog.hide();
                }
                else {
                    ToastService.showCustomToast("error","Form Invalid.");
                }
            };
            $scope.add = function(form) {
                form.$submitted=true;
                if(form.$valid){
                    $mdDialog.hide($scope.vm.NationalIdentifierData);
                }
                else {
                    ToastService.showCustomToast("error","Form Invalid.");
                }
            };


            $scope.cancel = function() {
                $mdDialog.hide();
            };
  
  
        }]);
})();